import * as React from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

type Props = {
    onClick: () => void;
    disabled?: boolean;
};
export const CreateArgumentButton = ({
    onClick,
    disabled = false,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    return (
        <Button variant="contained" onClick={onClick} disabled={disabled}>
            {t('budgetProposal.createEmptyArgument')}
        </Button>
    );
};
